export const BlockingView = () => (
  <div
    style={{
      position: 'fixed',
      inset: 0,
      zIndex: 10000,
      pointerEvents: 'auto',
    }}
  >
    <div style={{ position: 'relative', width: '100%', height: '100%' }}></div>
  </div>
);
